import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ToggleField from "widgets/ToggleField";
import { push } from "connected-react-router";
import { toggleAutoUpdates } from "reducers/actions/ContentFeedActions";

export default function ContentFeedAutoUpdates({ dependentValues }) {
	const dispatch = useDispatch();
	const { contentFeedId, contentFeedName, autoUpdateEnabled, libraryId, creativeCount } = dependentValues;
	const [isUpdating, setIsUpdating] = useState(false);

	const handleToggleAPI = (newAutoUpdateValue) => {
		setIsUpdating(true);
		dispatch(toggleAutoUpdates(contentFeedId, newAutoUpdateValue)).then(() => {
			setIsUpdating(false);
		});
	};

	const handleToggle = (autoUpdate) => {
		if (autoUpdateEnabled && !autoUpdate) {
			dispatch(push({
				pathname: `/library/${libraryId}/content-feeds/modal/toggle-auto-updates/${contentFeedId}/`,
				state: {
					contentFeedName,
					creativeCount,
				},
			}));
		} else if (!autoUpdateEnabled && autoUpdate) {
			handleToggleAPI(true);
		}
	};

	return (
		<ToggleField
			input={{
				value: autoUpdateEnabled,
				onChange: handleToggle,
			}}
			loading={isUpdating}
		/>
	);
}

ContentFeedAutoUpdates.displayName = "ContentFeedAutoUpdates";

